import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const PartyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  const [ledgerModalVisible, setLedgerModalVisible] = useState(false); 
  
  const [partyList, setPartyList] = useState([]);
  const [selectedParty, setSelectedParty] = useState('');
  const [ledgerData, setLedgerData] = useState('');

  const [addPartyMo, setAddPartyMo] = useState('');
  const [addPartyName, setAddPartyName] = useState('');
  const [addPartyType, setAddPartyType] = useState('');

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible || ledgerModalVisible) {
            if(ledgerModalVisible){
              setLedgerModalVisible(false);
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
            }
            
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, ledgerModalVisible]);

    useEffect(() => { 
      const fetchAccountList = async () => { 
          try {
            const response = await fetch(`${host_url}/account_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: '',
              }),
            });
            const data = await response.json();
            setPartyList(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAccountList(); 
    }, [host_url, store]);

    
    const [partyNameFilter, setPartyNameFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [balOperator, setBalOperator] = useState('');
    const [balValue, setBalValue] = useState('');

    const parseNum = v => {
      if (v === null || v === undefined) return null;
      const s = String(v).trim();
      if (s === "") return null;
      const n = Number(s);
      return Number.isFinite(n) ? n : null;
    };

    const applyOperator = (actual, op, value) => {
      // value assumed numeric (or null)
      if (op === '' || value === null) return true; // no operator/value => allow
      switch (op) {
        case '>':  return actual > value;
        case '>=': return actual >= value;
        case '<':  return actual < value;
        case '<=': return actual <= value;
        case '=':  return actual === value;
        case '!=': return actual !== value;
        default:   return true;
      }
    };

    console.log(partyList);
    const filteredPartyList = partyList.filter(party => {
      const safeLower = v =>
        v === null || v === undefined ? "" : String(v).toLowerCase();

      if (!safeLower(party.sacc_name).includes(partyNameFilter.toLowerCase()))
        return false;

      if (!safeLower(party.sacc_type).includes(typeFilter.toLowerCase()))
        return false;
        
      // BALANCE parsing
      const balance = Number(party.sacc_balance);
      if (!Number.isFinite(balance)) {
        // exclude non-numeric balances
        return false;
      }

      // APPLY OPERATOR FILTER
      const parsedBalValue = parseNum(balValue);
      if (balOperator && parsedBalValue !== null) {
        if (!applyOperator(balance, balOperator, parsedBalValue))
          return false;
      } 

      return true;
    });

    const totalCount = filteredPartyList.length;
    const totalBalance = filteredPartyList.reduce((sum, party) => sum + Number(party.sacc_balance), 0);
   
    const handleAccDetail = (party) => {
      setModalVisible(true);
      setSelectedParty(party);
    };

    // Functions for handling the different actions
    const handleAddParty = async () => {
      setAddModalVisible(false);
      const addDetail = {
              sacc_name: addPartyName,
              sacc_type: addPartyType,
              sacc_mo: addPartyMo,
      };
      try {
        const response = await fetch(`${host_url}/account_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'acc_insert',
            store: store,
            suId : '',
            accDetail: addDetail,
          }),
        });
        const data = await response.json();
        setPartyList(data);
        setAddPartyMo('');
        setAddPartyName('');
        setAddPartyType('');
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateParty = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/account_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'acc_update',
            store: store,
            accDetail: selectedParty,
          }),
        });
        const data = await response.json();
        setPartyList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleDeleteParty = async () => {
      setModalVisible(false);
      try {
        const response = await fetch(`${host_url}/account_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'acc_delete',
            store: store,
            accDetail: selectedParty,
          }),
        });
        const data = await response.json();
        if (data.message) {
            alert(data.message); 
        } else {
            setPartyList(data);
        }
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleLedger = async (row) => {
      setLedgerModalVisible(true);
      setSelectedParty(row);   
      try {
        const response = await fetch(`${host_url}/account_ledger`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store,
            sacc_id : row.sacc_id,
          }),
        });
        const data = await response.json();
        setLedgerData(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
      
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Account Master</b>
              <div onClick={() => setAddModalVisible(true)}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Name</th>
                <th>Type</th>
                <th>Balance</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={partyNameFilter}
                    onChange={(e) => setPartyNameFilter(e.target.value)}
                  />
                </th>
                <th>
                  <select
                    className="search-input"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="">All Types</option>
                    <option value="Pur_Party">Pur_Party</option>
                    <option value="Salary_Party">Salary_Party</option>
                    <option value="Exp_Party">Exp_Party</option>
                    <option value="Cash_Party">Cash_Party</option>
                    <option value="Bank_Party">Bank_Party</option>
                    {/* Add more roles as needed */}
                  </select>
                </th>
                <th> 
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <select
                      className="search-input"
                      style={{ width: '45%' }}
                      value={balOperator}
                      onChange={(e) => setBalOperator(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value=">">{'>'}</option>
                      <option value="<">{'<'}</option>
                      <option value=">=">{'>='}</option>
                      <option value="<=">{'<='}</option>
                      <option value="=">{'='}</option>
                      <option value="!=">{'!='}</option>
                    </select>

                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9\-\.]*"
                      className="search-input"
                      style={{ width: '40%', textAlign: 'center' }}
                      placeholder="Balance value"
                      value={balValue}
                      onChange={(e) => setBalValue(e.target.value)}
                    />
                  </div>    
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPartyList.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px', cursor: row.sacc_id < 10 ? 'default' : 'pointer', }} onClick={() => { if(row.sacc_id >= 10) handleAccDetail(row);}}>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.sacc_name}</span></td>
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.sacc_type}</span></td>
                      <td className="cell-right" onClick={(e) => { e.stopPropagation(); handleLedger(row);}} ><span style={{ paddingRight: '10px' }} >{row.sacc_balance}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left"></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalBalance}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Account Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Account Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td className="cell-left">Name</td>
                          <td><input type="text" value={selectedParty.sacc_name} onChange={(e) => setSelectedParty({ ...selectedParty, sacc_name: e.target.value })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Mobile No.</td>
                          <td><input type="text" maxLength="10" value={selectedParty.sacc_mo} onChange={(e) => setSelectedParty({ ...selectedParty, sacc_mo: e.target.value.replace(/[^0-9]/g, '').slice(0, 10) })} /></td>
                        </tr>
                        <tr>
                          <td className="cell-left">Type</td>
                          <td><select
                                value={selectedParty.sacc_type}
                                onChange={(e) => setSelectedParty({ ...selectedParty, sacc_type: e.target.value })}
                              >
                                <option value="Pur_Party">Pur_Party</option>
                                <option value="Salary_Party">Salary_Party</option>
                                <option value="Exp_Party">Exp_Party</option>
                                <option value="CashBank_Party">CashBank_Party</option>
                              </select>
                          </td>
                        </tr>
                      </tbody>  
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteParty}>
                      Delete
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateParty}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Account */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Party</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Name</td>
                        <td><input type="text" value={addPartyName} onChange={(e) => setAddPartyName(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Mobile No.</td>
                        <td><input type="text" maxLength="10" value={addPartyMo} onChange={(e) => setAddPartyMo(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left">Type</td>
                        <td><select
                              value={addPartyType}
                              onChange={(e) => setAddPartyType(e.target.value)}
                            >
                              <option value="">Select Types</option>
                              <option value="Pur_Party">Pur_Party</option>
                              <option value="Salary_Party">Salary_Party</option>
                              <option value="Exp_Party">Exp_Party</option>
                              <option value="Cash_Party">Cash_Party</option>
                              <option value="Bank_Party">Bank_Party</option>  
                            </select>
                        </td>                      
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddParty}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

          {/* Modal for Cash Ledger Detail */}
            <Modal isOpen={ledgerModalVisible} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >{selectedParty.sacc_name}</h5>  
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th className="cell-left" style={{ padding: '2px' }} >Date</th>
                          <th className="cell-left" style={{ padding: '2px' }} >Type</th>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >A/c. Name</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Credit</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px', }} >Debit</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {ledgerData && ledgerData.map((row, index) => {
                            return (
                              <tr key={index} style={{ cursor: 'pointer' }} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{new Date(row.date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                <td className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.tr_type}</td>
                                <td colSpan='2'className="cell-left" style={{ padding: '2px', fontSize: '14px' }} >{row.party_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.receipt || ''}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.payment || ''}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setLedgerModalVisible(false)}>
                                Close
                            </Button>
                          </th>
                          <th className="cell-left" style={{ padding: '2px' }} ></th>
                          <th colSpan='2' className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Total</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{Array.isArray(ledgerData) && ledgerData?.reduce((sum, ledger) => sum + (ledger.receipt || 0), 0) || 0}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{Array.isArray(ledgerData) && ledgerData?.reduce((sum, ledger) => sum + (ledger.payment || 0), 0) || 0}</th>
                        </tr> 
                      </tfoot>
                    </table>
                </div>
              </ModalBody>
            </Modal>      

    </div>
  );
};

export default PartyMaster;
